import { forwardRef, useEffect, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";

import "./C210LadenVoyagesFuelConsumption.scss"

import { Button, Label, TextArea } from "abs-ui-components";

import { AUTOSAVE_SUCCESS_MESSAGE, cSectionFormFields } from "../../Constants";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import AutoSave from "../../../../../common/AutoSave/AutoSave";

const C210LadenVoyagesFuelConsumption = forwardRef(({ c210FuelConsOnLadenVoyages,vesselMstId, refetchMonitoringData }, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    const { dirtyFields } = formState;
    const isC210Dirty = !!(dirtyFields?.c210 && Object.keys(dirtyFields.c210).length > 0);

    useEffect(() => {
        if (c210FuelConsOnLadenVoyages) {
            reset(prev => ({ ...prev, c210: c210FuelConsOnLadenVoyages }));
        }
    }, [c210FuelConsOnLadenVoyages, reset]);

    AutoSave(ref, [], async () => {
        if (!isC210Dirty) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("c210");
        const payload = {
            ...cSectionFormFields.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const c210LadenVoyagesFuelConsumption = await callApi({
                method: "POST",
                url: API_ROUTES.C210(vesselMstId),
                data: payload,
            });
            if (c210LadenVoyagesFuelConsumption?.isSuccess) {
                emitToasterMsg("success", "Table C.2.10", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, c210: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table C.2.10", c210LadenVoyagesFuelConsumption?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table C.2.10", error.errorMessage);
        }
    };

    return (
        <div className="c210-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">Determining and recording the fuel consumption on laden voyages</h6>
                </MDBCol>
            </MDBRow>

            {cSectionFormFields.map(({ label, name, maxLength }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`c210.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`c210_${name}`}
                                    className="textarea-resize"
                                    value={field?.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="c210_save_btn"
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}
                    disabled={!isC210Dirty}
                >Save</Button>
            </div>
        </div>
    );
});

export default C210LadenVoyagesFuelConsumption;